import { useQuery } from "react-query";
import { toast } from "react-toastify";
import axios from "axios";


export const useRegions = () => {

    const { data, isLoading } = useQuery<Array<any>>(
        ['regions'],
        () => {
            return axios.get(`${process.env.REACT_APP_ADDRESS_API}krankenkasse/regions`);
        }, {
        onError() {
            toast.error(`Something went wrong. Please try again later.`);
        },
    }
    );

    return {
        data,
        isLoading,
    };
};
